/**
 * Up to this many zonelog rules the stays are read one rule at a time: each read returns only stays. Above it
 * the reads per rule would run into Geotab's per-minute limit (thousands of zones), so the events of the
 * vehicles are read instead and filtered to our rules – a few pages, but with other rules' events in them.
 * Geotab ignores rule name, rule groups and zone in an ExceptionEvent search (live fairfleet 2026-11-04).
 */
export const PER_RULE_MAX = 50;

export type StayQueryPlan =
  | { kind: "perRule"; deviceId?: string }
  | { kind: "devices"; deviceSearch: { id: string } | { groups: { id: string }[] } };

export function stayQueryPlan({
  ruleCount,
  deviceIds,
  groupId,
}: {
  ruleCount: number;
  deviceIds: string[];
  /** „Zonelogs“ */
  groupId?: string;
}): StayQueryPlan {
  const single = deviceIds.length === 1 ? deviceIds[0] : undefined;
  if (ruleCount <= PER_RULE_MAX) return single ? { kind: "perRule", deviceId: single } : { kind: "perRule" };
  if (single) return { kind: "devices", deviceSearch: { id: single } };
  return groupId ? { kind: "devices", deviceSearch: { groups: [{ id: groupId }] } } : { kind: "perRule" };
}
